import React from "react";
import Header from "../../components/Header/index";
import AuthService from "../../services/AuthService";
import TextInput from "../../components/Form/components/TextInput";
import SelectInput from "../../components/Form/components/SelectInput";
import LoadingSpinner from "../../components/LoadingSpinner";
import MembersApi from "../../services/portal-api/MembersApi";
import swal from "sweetalert";
import withAuth from "../../services/withAuth";

class SecurityQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                q1: "",
                a1: "",
                q2: "",
                a2: "",
            },
            userName: AuthService.getName() || "",
            questions: [],
            isLoading: false,
        }
    }

    componentDidMount() {
        document.title = 'Customise Security Questions - Dusk Portal';
        document.body.className = '';
        this.fetchSecurityQuestions();
        this.getUserQA();
    }

    fetchSecurityQuestions = () => {
        MembersApi.getQuestions((response) => {
            if (response.success) {
                const questionsArr = response.json.questions.map((question) => ({
                    key: question.id,
                    value: question.question,
                }));
                this.setState({ questions: questionsArr });
            }
        });
    };

    getUserId = () => {
        const url = window.location.href;
        const userId = url.split('/').pop();
        return userId;
    }

    getUserQA = () => {
        MembersApi.getUserQA((response) => {
            this.setState({
                data: {
                    q1: response.json.data.first.question,
                    a1: response.json.data.first.answer,
                    q2: response.json.data.second.question,
                    a2: response.json.data.second.answer,
                }
            })
        }, this.getUserId());
    }

    handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let data = this.state.data;
        data[name] = value;
        this.setState({
            data: data
        }, () => {
            if(this.state.data.q1 == this.state.data.q2) {
                swal("Question 1 and Question 2 can not be same", {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                });

                this.setState({
                    data: {
                        q1: "",
                        a1: "",
                        q2: "",
                        a2: "",
                    }
                })
            }
        })
    }

    handleSubmitQuestion = (event) => {
        event.preventDefault();
        this.setState({ isLoading: true });
        const data = this.state.data;
        const params = {
            "q1": data.q1,
            "a1": data.a1,
            "q2": data.q2,
            "a2": data.a2,
            "userId": this.getUserId()
        }
        MembersApi.updateUserQA(params, (response) => {
            this.setState({ isLoading: false });
            if (response.success) {
                swal("Security Questions Updated Successfully", {
                    icon: "success",
                    buttons: false,
                    timer: 3000
                });

                this.props.history.replace('/');
            } else {
                swal(response.message, {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                });
            }
        });
    }

    render() {
        return (
            <div>
                <Header />
                <main className="content" role="main">
                    <div className="container padding--40">
                        <h3 style={{fontStyle:"italic"}} className="padding--40--bot">
                            <u>Hi {this.state.userName}, Please customise the questions below in order for you to reset your password in the future.</u>
                        </h3>
                        <form onSubmit={this.handleSubmitQuestion} className="margin--20--top validate loading--inline padding--20--bot" autoComplete="off">
                            <div className="col gutter--20">
                                <div className="col">
                                    <SelectInput
                                        name="q1"
                                        label="First Question"
                                        options={this.state.questions}
                                        value={this.state.data.q1}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                                <div className="col">
                                    <TextInput
                                        name="a1"
                                        label="Your Answer"
                                        placeholder=""
                                        value={this.state.data.a1}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <div className="col gutter--20">
                                <div className="col">
                                    <SelectInput
                                        name="q2"
                                        label="Second Question"
                                        options={this.state.questions}
                                        value={this.state.data.q2}
                                        onChange={this.handleInput}
                                        required={true}
                                        
                                    />
                                </div>
                                <div className="col">
                                    <TextInput
                                        name="a2"
                                        label="Your Answer"
                                        placeholder=""
                                        value={this.state.data.a2}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <footer className="footer--form clearfix">
                                <div className="footer--form__left">
                                </div>
                                <div className="footer--form__right">
                                    <button type="submit" className="btn btn--large btn--color">Save</button>
                                </div>
                            </footer>
                            <LoadingSpinner isVisible={this.state.isLoading} />
                        </form>
                    </div>
                </main>
            </div>
        );
    }
}

export default withAuth(SecurityQuestions);
